import { defineStore } from 'pinia'

export const usePaymentStore = defineStore('payment', {
  state: () => ({
    payment: {
      orderNumber: '',
      type: '',
      amount: '',
      currencyCode: ''
    },
    terminals: [],
    terminalTransaction: null,
    lastTerminalTransaction: null, // Store last terminal transaction (capture/refund) for verification retry
    expectedDeliverySlips: 0
  }),
  getters: {
    getPayment: (state) => state.payment,
    getTerminals: (state) => state.terminals,
    getTerminalTransaction: (state) => state.terminalTransaction,
    getLastTerminalTransaction: (state) => state.lastTerminalTransaction,
    hasFailedTerminalTransaction: (state) => state.lastTerminalTransaction !== null
  },
  actions: {
    resetTerminalTransaction() {
      this.terminalTransaction = null
    },
    setLastTerminalTransaction(transaction) {
      this.lastTerminalTransaction = transaction
    },
    resetLastTerminalTransaction() {
      this.lastTerminalTransaction = null
    }
  }
})
